import { render, staticRenderFns } from "./GeraAtividades.vue?vue&type=template&id=309a3a0b"
import script from "./GeraAtividades.vue?vue&type=script&lang=js"
export * from "./GeraAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports